const globals = {
  currentProjectStateDefinitionVersion: '0.4.0',
}

export default globals
